<template>
  <export-to-platform
    v-bind="$attrs"
    platform="google"
    @essays-exported="$emit('essays-exported')"
  ></export-to-platform>
</template>

<script>
import ExportToPlatform from "./export_to_platform";
export default {
  name: "ExportToGoogleModal",

  components: {
    ExportToPlatform,
  },
};
</script>
